import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/img/arrow.down.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-4 mb-5" }, null, -1)
const _hoisted_4 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_5 = { class: "whiteBox my-4" }
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "table table-striped" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { colspan: "99" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "form-group mb-0" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  style: {"position":"absolute","right":"2px"},
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "total" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_24 = {
  key: 3,
  class: "d-flex justify-content-end mt-3"
}
const _hoisted_25 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_edit_layer_production_process = _resolveComponent("edit-layer-production-process")!
  const _component_edit_layer_transportation = _resolveComponent("edit-layer-transportation")!
  const _component_layer_water_footprint = _resolveComponent("layer-water-footprint")!
  const _component_view_weastage_data = _resolveComponent("view-weastage-data")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_ctx.loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.showOnlyProcess && _ctx.layerCompositions.length == 0)
          ? (_openBlock(), _createBlock(_component_localized_text, {
              key: 0,
              type: "h4",
              localizedKey: "-- No processes or transportation are required for this phase",
              text: "-- No processes or transportation are required for this phase",
              class: "mt-3 mb-5 pb-5"
            }))
          : _createCommentVNode("", true),
        (!_ctx.showOnlyProcess)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.layerCompositions, (layer) => {
              return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(_component_localized_text, {
                  type: "h3",
                  localizedKey: "Fabric {{layerName}}",
                  text: "Fabric {{layerName}}",
                  object: { layerName: layer.layerName},
                  class: "mb-5"
                }, null, 8, ["object"]),
                (_openBlock(), _createBlock(_component_edit_layer_production_process, {
                  estimationIdentifier: _ctx.estimationIdentifier,
                  layer: layer,
                  countries: _ctx.electricityCountries,
                  allProductionProcesses: _ctx.allProductionProcesses,
                  currentProductionProcesses: _ctx.layerProductionProcesses[layer.layerName],
                  productionPhase: _ctx.productionPhase,
                  isReadOnly: _ctx.isReadOnly,
                  onInit: _ctx.init,
                  key: layer.layerName + _ctx.productionPhase,
                  class: "mb-5"
                }, null, 8, ["estimationIdentifier", "layer", "countries", "allProductionProcesses", "currentProductionProcesses", "productionPhase", "isReadOnly", "onInit"])),
                (_openBlock(), _createBlock(_component_edit_layer_transportation, {
                  estimationIdentifier: _ctx.estimationIdentifier,
                  countries: _ctx.electricityCountries,
                  transportDistanceCalculation: _ctx.transportationCountries,
                  layer: layer,
                  currentTransportation: _ctx.layerTransportPhases[layer.layerName],
                  isReadOnly: _ctx.isReadOnly,
                  productionPhase: _ctx.productionPhase,
                  saveCallback: _ctx.saveTransportationCallback,
                  removeCallback: _ctx.removeCallback,
                  onInit: _ctx.init,
                  key: layer.layerName + _ctx.productionPhase,
                  class: "pb-3"
                }, null, 8, ["estimationIdentifier", "countries", "transportDistanceCalculation", "layer", "currentTransportation", "isReadOnly", "productionPhase", "saveCallback", "removeCallback", "onInit"])),
                (_ctx.waterFootprints[layer.layerName].filter(x => x.productionPhase.text == _ctx.productionPhase).length > 0)
                  ? (_openBlock(), _createBlock(_component_layer_water_footprint, {
                      key: 0,
                      productionPhase: _ctx.productionPhase,
                      currentWaterFootprints: _ctx.waterFootprints[layer.layerName],
                      class: "pb-3"
                    }, null, 8, ["productionPhase", "currentWaterFootprints"]))
                  : _createCommentVNode("", true)
              ]))
            }), 256))
          : _createCommentVNode("", true),
        _createVNode(_component_view_weastage_data, {
          allProductionProcesses: _ctx.layerProductionProcesses,
          productionPhase: _ctx.productionPhase,
          layers: _ctx.layerCompositions
        }, null, 8, ["allProductionProcesses", "productionPhase", "layers"]),
        (_ctx.indipendentProductionProcess.length > 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(["mb-5", _ctx.showOnlyProcess ? '' : 'mt-5'])
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_form_field, {
                  type: "number",
                  labelKey: "Height of roll (m)",
                  labelValue: "Height of roll (m)",
                  placeholderKey: "Height of roll (m)",
                  placeholderValue: "Height of roll (m)",
                  class: "w-100 me-2",
                  modelValue: _ctx.heightOfRoll,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.heightOfRoll) = $event)),
                  readonly: _ctx.isReadOnly
                }, null, 8, ["modelValue", "readonly"]),
                _createVNode(_component_form_field, {
                  type: "number",
                  labelKey: "Length of fabric (m)",
                  labelValue: "Length of fabric (m)",
                  placeholderKey: "Length of fabric (m)",
                  placeholderValue: "Length of fabric (m)",
                  class: "w-100 me-2",
                  modelValue: _ctx.lengthOfFabric,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lengthOfFabric) = $event)),
                  readonly: _ctx.isReadOnly
                }, null, 8, ["modelValue", "readonly"])
              ]),
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_localized_text, {
                  type: "h3",
                  localizedKey: "Additional Material",
                  text: "Additional Material"
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("table", _hoisted_7, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Production Group",
                            text: "Production Group"
                          })
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Process Name",
                            text: "Process Name"
                          })
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "CO2e",
                            text: "CO2e"
                          })
                        ]),
                        (_ctx.indipendentProductionProcess.some(x => !x.isElectricityEmissionIndipendent))
                          ? (_openBlock(), _createElementBlock("td", _hoisted_8, [
                              _createVNode(_component_localized_text, {
                                localizedKey: "Production Country",
                                text: "Production Country"
                              })
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", null, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Value",
                            text: "Value"
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_ctx.indipendentProductionProcess.length == 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                            _createElementVNode("td", _hoisted_10, [
                              _createVNode(_component_localized_text, {
                                localizedKey: "No Elements Found",
                                text: "No Elements Found"
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indipendentProductionProcess, (item, indice) => {
                        return (_openBlock(), _createElementBlock("tr", { key: indice }, [
                          _createElementVNode("td", null, [
                            (item.productionGroup)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(item.productionGroup), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_12, "--"))
                          ]),
                          _createElementVNode("td", _hoisted_13, [
                            (item.isUnique && !_ctx.isReadOnly)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "position-relative form-control d-flex align-items-center pointer pe-4",
                                  onClick: ($event: any) => (_ctx.editAdditionalLayerProductionProcess(item))
                                }, [
                                  _createTextVNode(_toDisplayString(item.name) + " ", 1),
                                  _hoisted_15
                                ], 8, _hoisted_14))
                              : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(item.name), 1))
                          ]),
                          _createElementVNode("td", null, _toDisplayString(_ctx.$filters.approximation(item.cO2e)), 1),
                          _createElementVNode("td", null, [
                            (item.productionCountry.text && !item.isElectricityEmissionIndipendent)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(item.productionCountry.text), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_18, "--"))
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_form_field, {
                              type: "number",
                              placeholderKey: "Value",
                              placeholderValue: "Value",
                              min: "0",
                              modelValue: _ctx.editEstimationLayerProductionProcessList[indice].units,
                              "onUpdate:modelValue": [($event: any) => ((_ctx.editEstimationLayerProductionProcessList[indice].units) = $event), ($event: any) => (_ctx.updateValue(indice))],
                              readonly: _ctx.isReadOnly
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"])
                          ])
                        ]))
                      }), 128)),
                      _createElementVNode("tr", _hoisted_19, [
                        _createElementVNode("td", null, [
                          _createElementVNode("strong", null, [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Total",
                              text: "Total"
                            })
                          ])
                        ]),
                        _hoisted_20,
                        _createElementVNode("td", null, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.$filters.approximation(_ctx.$utils.getTotal("cO2e", _ctx.indipendentProductionProcess))), 1)
                        ]),
                        _hoisted_21,
                        (_ctx.indipendentProductionProcess.some(x => !x.isElectricityEmissionIndipendent))
                          ? (_openBlock(), _createElementBlock("td", _hoisted_22))
                          : _createCommentVNode("", true),
                        _hoisted_23
                      ])
                    ])
                  ])
                ])
              ])
            ], 2))
          : _createCommentVNode("", true),
        (!_ctx.isReadOnly)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("button", {
                class: "btn btn-secondary me-3",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.back()))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Previous",
                  text: "Previous"
                })
              ]),
              _createElementVNode("button", {
                class: "btn btn-tertiary",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.next())),
                disabled: _ctx.disabled
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Continue",
                  text: "Continue"
                })
              ], 8, _hoisted_25)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}